(function ($) {
    var currentSlide = 1;

    window.B.Login = {
        init: function (isPcOrTablet, callBackUrl, ) {
            if (this.getIsInit() || !isPcOrTablet) {
                return;
            }

            this.insertLoginHtml(callBackUrl);
            this.initSlide();
        },

        getIsInit: function () {
            if (document.body.querySelector('.layer_login')) {
                return true;
            } else {
                return false;
            }
        },

        insertLoginHtml: function (callBackUrl) {
            var loginPopupHtml = B.Util.getTemplate('login-layer-popup.hbs', {
                callBackUrl: callBackUrl
            });
            $('body').append(loginPopupHtml);
        },

        initSlide: function () {
            $('#closeSigninPopup').on('click', function (e) {
                e.preventDefault();
                $('.layer_login').hide();
            });

            $('#topStartBrunchButton, #brunchSigninButton').on('click', function (e) {
                e.preventDefault();
                B.Util.requireSignin();
            });

            $('.sign_kakao3').on('click', function (e) {
                e.stopPropagation();
            });

            $('.layer_login').on('click', function (e) {
                $('.layer_login').hide();
            });

            $('.btn_arrow.btn_prev').on('click', $.proxy(this.prevSlide, this));
            $('.btn_arrow.btn_next').on('click', $.proxy(this.nextSlide, this));
        },

        mobileInitSlide: function () {
            $('.start_slide').touchFlick({
                roll: false,
                sidePage: true,
                transition: false,
                counter: function (infoObj) {
                    $('.start_slide .list_slide').removeClass('slide1 slide2 slide3');
                    $('.start_slide .list_slide').addClass('slide' + infoObj.current);
                    $('.paging_item .link_page').removeClass('active');
                    $('.paging_item .link_page.slide' + infoObj.current).addClass('active');
                }
            });
        },

        showSlide: function (currentIndex) {
            $('.slide_box .list_slide')
                .removeClass('slide1 slide2 slide3')
                .addClass('slide' + currentIndex).fadeIn(500);
            $('.paging_box .btn_paging').removeClass('on');
            $('.paging_box .btn_paging.slide' + currentIndex).addClass('on');
        },

        nextSlide: function () {
            currentSlide = (currentSlide % 3) + 1;
            this.showSlide(currentSlide);
        },

        prevSlide: function () {
            currentSlide = ((currentSlide + 1) % 3) + 1;
            this.showSlide(currentSlide);
        },

        changeSlide: function () {
            this.nextSlide();
        },

        startSlide: function () {
            setInterval($.proxy(this.changeSlide, this), 4000);
        },

        proceedSignin: function (isPcOrTablet, callBackUrl) {
            var loginCallBackUrl = callBackUrl;

            if (loginCallBackUrl && B.Util.hasXss(loginCallBackUrl)) {
                loginCallBackUrl = B.Util.escapeSpecialChar(callBackUrl);
                console.error('callbackUrl has xss', callBackUrl, 'escapedUrl', loginCallBackUrl);
            }

            if (!this.getIsInit()) {
                this.init(isPcOrTablet, loginCallBackUrl);
            }

            if (isPcOrTablet) {
                $('.layer_login').show();
                this.startSlide();
                T.newPage()
                    .setName('브런치 시작하기')
                    .setSection('account')
                    .setPage('login')
                    .setActionKind('Login')
                    .track();
            } else {
                //TODO IndexController 에서 redirect 처리를 했으니 여기 진입할 일이 없어야하는데 혹시 몰라서 로그 남겨놓음.
                console.error('signin redirect happened with', callBackUrl, 'escapedUrl', loginCallBackUrl);
                var url = '/signin?url=' + encodeURIComponent(loginCallBackUrl);
                window.location.href = url;
            }
        }
    };
})(jQuery);
